import Box from '@mui/material/Box';
import { useLayoutEffect, useRef, useState } from 'react';

const DEFAULT_SPEED = 10;

const PingPongText = ({ text, speed = DEFAULT_SPEED, sx }) => {
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const [distance, setDistance] = useState(0);

  useLayoutEffect(() => {
    const container = containerRef.current;
    const textEl = textRef.current;
    if (!container || !textEl) return;

    const update = () => {
      const next = Math.max(0, textEl.scrollWidth - container.clientWidth);
      setDistance(current => (current === next ? current : next));
    };

    update();

    const observer = new ResizeObserver(update);
    observer.observe(container);
    observer.observe(textEl);
    window.addEventListener('resize', update);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', update);
    };
  }, [text]);

  return (
    <Box
      ref={containerRef}
      component="span"
      sx={[
        { display: 'block', width: '100%', overflow: 'hidden', whiteSpace: 'nowrap' },
        ...(sx ? (Array.isArray(sx) ? sx : [sx]) : []),
      ]}>
      <Box
        ref={textRef}
        component="span"
        style={{ '--ping-pong-distance': `${distance}px` }}
        sx={{
          display: 'inline-block',
          whiteSpace: 'nowrap',
          transform: 'translateX(0)',
          willChange: distance ? 'transform' : 'auto',
          ...(distance > 0 && {
            animation: `pingPongText ${distance / (speed > 0 ? speed : DEFAULT_SPEED)}s linear infinite alternate`,
            '@keyframes pingPongText': {
              to: { transform: 'translateX(calc(var(--ping-pong-distance) * -1))' },
            },
          }),
        }}>
        {text}
      </Box>
    </Box>
  );
};

export default PingPongText;
